import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import { Button, Card, CardBody, Col, Input, Label, Row } from "reactstrap"
import { AvField, AvForm } from "availity-reactstrap-validation"
import Select from "react-select"
import { useDispatch, useSelector } from "react-redux"
import {
  createInspection,
  getBrands,
  getDistricts,
  getInspectionsBooking,
  getModels,
  getStates,
  getUsers,
  getVariants,
  getVehicles,
  updateInspection,
} from "store/actions"
import { useLocation, useParams } from "react-router-dom"
import { useHistory } from "react-router-dom"
import { InspectionDocumentsParameters } from "./parameters"

function Form({ updateData }) {
  const dispatch = useDispatch()
  const params = useParams()
  const history = useHistory()
  const location = useLocation()

  const bookingNo = location.state?.bookingNo

  const [isFeatured, setIsFeatured] = useState(false)
  const isTablet = window.innerWidth <= 768
  const [status, setStatus] = useState("diesel")

  const [vehicle, setVehicle] = useState("Select Vehicle...")
  const [vehicleId, setVehicleId] = useState("")
  const [vehicleSearch, setVehicleSearch] = useState("")

  const [modelValue, setModelValue] = useState("Select Vehicle Model")
  const [modelId, setModelValueId] = useState()
  const [modelSearch, setModelSearch] = useState("")

  const [brandValue, setBrandValue] = useState("Select Vehicle Brand")
  const [brandId, setBrandId] = useState()
  const [brandSearch, setBrandSearch] = useState("")

  const [varientValue, setVarientValue] = useState("Select Vehicle Variant")
  const [variantId, setVariantId] = useState()
  const [varientSearch, setVarientSearch] = useState("")

  const [state, setState] = useState("Select State")
  const [stateId, setStateId] = useState("")
  const [stateSearch, setStateSearch] = useState("")

  const [district, setDistrict] = useState("Select District")
  const [districtId, setDistrictId] = useState(null)
  const [districtSearch, setDistrictSearch] = useState("")

  const [staff, setStaff] = useState("Select Staff...")
  const [staffId, setStaffId] = useState(null)
  const [staffSearch, setStaffSearch] = useState("")

  const [booking, setBooking] = useState("Select Booking...")
  const [bookingId, setBookingId] = useState(null)
  const [bookingSearch, setBookingSearch] = useState("")
  const {
    inspectionDetails,
    allVehicle,
    model,
    brand,
    varient,
    allState,
    allDistricts,
    allUser,
    AllInspectionBookings,
    loadingCreate,
  } = useSelector(state => ({
    inspectionDetails: state.Inspection?.inspectionDetails,
    allVehicle: state.Vehicle.vehicles?.vehicles,
    model: state.Model.models?.models,
    brand: state.Brand.brands?.brands,
    varient: state.Varient.variants?.variants,
    allState: state?.Client?.states?.States,
    allDistricts: state?.Client?.districts?.districts,
    allUser: state.Members.users,
    AllInspectionBookings: state.Inspection.inspectionsBooking?.bookings,
    loadingCreate: state.Inspection.loadingCreate,
  }))

  useEffect(() => {
    dispatch(getModels(1, 10, modelSearch, brandId))
  }, [modelSearch, brandId])

  useEffect(() => {
    dispatch(getBrands(1, "", 10, brandSearch))
  }, [brandSearch])

  useEffect(() => {
    dispatch(getVariants(1, 10, varientSearch, modelId))
  }, [varientSearch, modelId])

  useEffect(() => {
    dispatch(
      getVehicles("", "", vehicleSearch, "", "", "", "", "", "", "", "", "")
    )
  }, [dispatch, vehicleSearch])

  const handleSubmit = (e, values) => {
    const inspection = {
      // ...values,
      inspection_data: {
        inspected_date: values?.inspected_date,
        inspection_number: values?.inspection_number,
        inspected_by: staffId || null,
      },
      vehicle_data: {
        vehicle_number: values?.vehicle_number,
        vehicle_name: values?.vehicle_name,
        vehicle_brand: brandId || null,
        vehicle_model: modelId || null,
        vehicle_variant: variantId || null,
        variant_name: values?.vehicle_variant_text || null,
        vehicle_year: values?.vehicle_year,
        current_kilometer: values?.current_kilometer,
        // vehicle_fuel_type: values?.vehicle_fuel_type,
        vehicle_fuel_type: status?.value,
      },
      owner_details: {
        customer_name: values?.customer_name,
        phone_number: values?.phone_number,
        address: values?.address,
        district: districtId || null,
        state: stateId || null,
      },
      finance: isFeatured,
      check_metrics: values?.check_metrics,
      vehicle: vehicleId || null,
      replacement_report: values?.replacement_report,
      remarks: values?.remarks,
      booking_id: bookingNo || bookingId || null,
    }

    if (params?.id) {
      dispatch(updateInspection(inspection, inspectionDetails?._id, history))
    } else {
      dispatch(createInspection(inspection, history))
    }
  }

  const handleEnters = textEntered => {
    setModelSearch(textEntered)
  }

  function handlerFinalValueModel(event) {
    if (event?.label === "Clear") {
      setModelValue(event.value)
      setModelValueId(null)
    } else {
      setModelValue(event.label)
      setModelValueId(event.value)
    }
  }

  const modelOptions = [
    {
      label: "Clear",
      value: "select a model",
    },
    ,
    {
      options: (model?.length >= 1 ? model : [])?.map((results, index) => ({
        key: index,
        label: results.name,
        value: results._id,
      })),
    },
  ]

  const handleEnter = textEntered => {
    setBrandSearch(textEntered)
  }

  function handlerFinalValuesBrand(event) {
    if (event?.label === "Clear") {
      setBrandValue(event.value)
      setBrandId(null)
    } else {
      setBrandValue(event.label)
      setBrandId(event.value)
    }
  }

  const brandOptions = [
    {
      label: "Clear",
      value: "select a brand",
    },
    {
      options: (brand?.length >= 1 ? brand : [])?.map((results, index) => ({
        key: index,
        label: results.name,
        value: results._id,
      })),
    },
  ]

  const handleEntered = textEntered => {
    setVarientSearch(textEntered)
  }

  function handleFinalValuesVarient(event) {
    if (event?.label === "Clear") {
      setVarientValue(event?.value)
      setVariantId(null)
    } else {
      setVarientValue(event.label)
      setVariantId(event.value)
    }
  }

  const varientOptions = [
    {
      label: "Clear",
      value: "select a varient",
    },
    {
      options: (varient?.length >= 1 ? varient : [])?.map((results, index) => ({
        key: index,
        label: results.name,
        value: results._id,
      })),
    },
  ]

  useEffect(() => {
    if (vehicleId) {
      setBrandId(vehicle?.brandId || "")
      setBrandValue(vehicle?.brand || "")
      setModelValue(vehicle?.model || "")
      setModelValueId(vehicle?.modelId || "")
      setVarientValue(vehicle?.variant || "")
      setVariantId(vehicle?.variantId || "")
    }
  })

  // states
  useEffect(() => {
    dispatch(getStates(stateSearch))
  }, [dispatch, stateSearch])

  const stateOptions = [
    {
      options: allState?.map((result, index) => ({
        key: index,
        label: result?.name,
        value: result._id,
      })),
    },
  ]

  const handleEnteredStates = textEntered => {
    setStateSearch(textEntered)
  }

  function handleFinalValuesStates(event) {
    setState(event.label)
    setStateId(event.value)
    // history.push(updatedLocation)
  }
  // district

  useEffect(() => {
    if (stateId) {
      dispatch(getDistricts(stateId, districtSearch))
    }
  }, [dispatch, stateId, districtSearch])

  const districtOptions = [
    // {
    //   label: "All",
    //   value: "",
    // },
    {
      options: allDistricts?.map((result, index) => ({
        key: index,
        label: result?.name,
        value: result._id,
      })),
    },
  ]

  const handleEnteredDistrict = textEntered => {
    setDistrictSearch(textEntered)
  }

  function handleFinalValuesDistrict(event) {
    setDistrict(event.label)
    setDistrictId(event.value)
  }
  // inspection user staffs
  useEffect(() => {
    dispatch(getDistricts(stateId))
  }, [dispatch, stateId])

  useEffect(() => {
    dispatch(getUsers("", "", staffSearch, "", "inspectionUser"))
  }, [dispatch, staffSearch])

  const staffOptions = [
    {
      options: allUser?.users?.map((result, index) => ({
        key: index,
        label: result?.name,
        value: result._id,
      })),
    },
  ]

  const handleEnteredStaff = textEntered => {
    setStaffSearch(textEntered)
  }

  function handleFinalValuesStaff(event) {
    setStaff(event.label)
    setStaffId(event.value)
  }

  useEffect(() => {
    dispatch(getInspectionsBooking("", "NEW", "", bookingSearch, ""))
  }, [dispatch, bookingSearch])

  const bookingOptions = [
    {
      options: AllInspectionBookings?.map((result, index) => ({
        key: index,
        label: result?.booking_id,
        value: result._id,
        name: result?.user_details?.name,
        phone: result?.user_details?.phone,
      })),
    },
  ]

  const handleEnteredBooking = textEntered => {
    setBookingSearch(textEntered)
  }

  function handleFinalValuesBooking(event) {
    setBooking(event)
    setBookingId(event.label)
  }
  useEffect(() => {
    setBookingId(updateData?.label)
    setBooking(updateData?.label)
    setVehicleId(updateData?.vehicle?._id)
    setVehicle(updateData?.vehicle)
  }, [updateData])

  const inspectionSections = [
    {
      title: "1. Vehicle History",
      data: InspectionDocumentsParameters?.vehicleHistory?.items,
      checkMetricIndex: 0,
      isSub: false,
    },
    {
      title: "2. Road Test",
      data: InspectionDocumentsParameters?.roadTest?.items,
      checkMetricIndex: 1,
      isSub: false,
    },
    {
      title: "3. Vehicle Exterior",
      data: InspectionDocumentsParameters?.vehicleExterior?.subHeads,
      checkMetricIndex: 2,
      isSub: true,
    },
    {
      title: "4. Vehicle Interior",
      data: InspectionDocumentsParameters?.vehicleInterior?.subHeads,
      checkMetricIndex: 3,
      isSub: true,
    },
    {
      title: "5. Vehicle Diagnostic",
      data: InspectionDocumentsParameters?.vehicleDiagnostics?.items,
      checkMetricIndex: 4,
    },
    {
      title: "6. Underhood Components",
      data: InspectionDocumentsParameters?.underhoodComponents?.subHeads,
      checkMetricIndex: 5,
      isSub: true,
    },
    {
      title: "7. UnderBody Components",
      data: InspectionDocumentsParameters?.underbodyComponents?.subHeads,
      checkMetricIndex: 6,
      isSub: true,
    },
    {
      title: "8. Final Check",
      data: InspectionDocumentsParameters?.finalChecks?.items,
      checkMetricIndex: 7,
      isSub: false,
    },
  ]
  const [openSections, setOpenSections] = useState([])
  const fuelTypeOptions = [
    {
      id: 1,
      label: "DIESEL",
      value: "diesel",
    },
    {
      id: 2,
      label: "PETROL",
      value: "petrol",
    },
    {
      id: 3,

      label: "ELECTRIC",
      value: "electric",
    },
    {
      id: 4,
      label: "CNG",
      value: "cng",
    },
  ]
  useEffect(() => {
    if (vehicle?.fuelType) {
      const matched = fuelTypeOptions.find(s => s.value === vehicle.fuelType)
      setStatus(matched || null)
    }
  }, [vehicle])

  const getGlobalIndex = (sectionIdx, subHeadIdx, itemIdx) => {
    let count = 0
    for (let i = 0; i < sectionIdx; i++) {
      const sec = inspectionSections[i]
      if (sec.isSub && Array.isArray(sec.data)) {
        sec.data.forEach(sub => {
          count += sub.item.length
        })
      } else if (Array.isArray(sec.data)) {
        count += sec.data.length
      }
    }
    // Add previous subHeads in this section
    if (subHeadIdx !== undefined) {
      for (let j = 0; j < subHeadIdx; j++) {
        count +=
          sectionIdx >= 0 && inspectionSections[sectionIdx].data[j].item.length
      }
      count += itemIdx
    } else {
      count += itemIdx
    }
    return count + 1
  }
  return (
    <div>
      <AvForm
        onValidSubmit={(e, v) => {
          handleSubmit(e, v)
        }}
      >
        <Row className="position-relative">
          <>
            <Col xs="12" sm="12" md="12" lg="12">
              <Card className="">
                <CardBody
                  className="my-2 mx-1 custom-card"
                // style={{ position: "relative" }}
                >
                  <>
                    <Row className="bg-light px-1 py-2 mb-3 heading-document">
                      <Col>
                        <span>INSPECTION DATA</span>
                      </Col>
                    </Row>

                    <Row className="pt-2 mb-4 mt-3">
                      <Col md={4}>
                        <label>
                          Inspection Date
                          <span className="text-danger">*</span>
                        </label>
                        <AvField
                          name="inspected_date"
                          // label="Inspection Date"
                          placeholder="Enter Inspection Date.."
                          type="date"
                          validate={{
                            required: {
                              value: true,
                              errorMessage: "Inspection Date is required",
                            },
                          }}
                          value={new Date().toISOString().split("T")[0]}
                        />
                      </Col>

                      <Col md={4}>
                        <label>Inspected By</label>
                        <Select
                          onInputChange={handleEnteredStaff}
                          value={staff}
                          placeholder={staff}
                          onChange={handleFinalValuesStaff}
                          options={staffOptions}
                          classNamePrefix="select2-selection"
                          isLoading={""}
                        />
                      </Col>
                      {!bookingNo && (
                        <Col md={4}>
                          <label>Booking No.</label>
                          <Select
                            onInputChange={handleEnteredBooking}
                            value={booking}
                            placeholder={booking}
                            onChange={handleFinalValuesBooking}
                            options={bookingOptions}
                            classNamePrefix="select2-selection"
                            isLoading={""}
                            isRequired={true}
                          />
                        </Col>
                      )}
                    </Row>

                    <Row className="bg-light px-1 py-2 mb-3 heading-document">
                      <Col>
                        <span>VEHICLE DATA</span>
                      </Col>
                    </Row>

                    <Row>
                      <Col>
                        <label>
                          Vehicle Brand
                          <span className="text-danger">*</span>
                        </label>
                        <Select
                          onInputChange={handleEnter}
                          value={brandValue}
                          placeholder={brandValue}
                          onChange={handlerFinalValuesBrand}
                          options={brandOptions}
                          classNamePrefix="select2-selection"
                          isRequired={true}
                        />
                      </Col>
                      <Col>
                        <label> Vehicle Model</label>
                        <Select
                          onInputChange={handleEnters}
                          value={modelValue}
                          placeholder={modelValue}
                          onChange={handlerFinalValueModel}
                          options={modelOptions}
                          classNamePrefix="select2-selection"
                          isRequired={true}
                        />
                      </Col>

                      <Col>
                        <label>Search Variant</label>
                        <Select
                          onInputChange={handleEntered}
                          value={
                            variantId
                              ? { label: varientValue, value: variantId }
                              : null
                          }
                          placeholder="Search variant..."
                          onChange={handleFinalValuesVarient}
                          options={varientOptions}
                          classNamePrefix="select2-selection"
                        />
                      </Col>

                      <Col>
                        <label>Vehicle Variant</label>
                        <AvField
                          name="vehicle_variant_text"
                          value={
                            varientValue === "Select Vehicle Variant" ||
                              varientValue === "select a varient"
                              ? ""
                              : varientValue
                          }
                          onChange={e => {
                            setVarientValue(e.target.value)
                            setVariantId(null)
                          }}
                          placeholder="Enter Vehicle Variant"
                          type="text"
                        />
                      </Col>

                      <Col>
                        <label>
                          Registration Number
                          <span className="text-danger">*</span>
                        </label>
                        <AvField
                          name="vehicle_number"
                          placeholder="Enter Vehicle Number"
                          type="text"
                          value={updateData?.vehicle_data?.vehicle_number}
                          validate={{
                            required: {
                              value: true,
                              errorMessage: "Vehicle Number is required",
                            },
                          }}
                        />
                      </Col>
                    </Row>
                    <Row className="pt-3">
                      <Col md={3}>
                        <label>Vehicle Name</label>
                        <AvField
                          name="vehicle_name"
                          placeholder="Enter Vehicle Name"
                          type="text"
                        />
                      </Col>

                      <Col md={3}>
                        <label>Year</label>
                        <AvField
                          name="vehicle_year"
                          placeholder="Enter Vehicle Year"
                          type="text"
                        />
                      </Col>

                      <Col md={3}>
                        <label>KMs</label>
                        <AvField
                          name="current_kilometer"
                          placeholder="Current KMs"
                          type="text"
                        />
                      </Col>
                      <Col md={3}>
                        <label>Fuel Type</label>

                        <Select
                          value={status}
                          onChange={setStatus}
                          options={fuelTypeOptions}
                          classNamePrefix="select2-selection"
                          placeholder="Select Fuel Type"
                        />
                      </Col>
                    </Row>

                    <Row className="bg-light px-1 mt-3 py-2 mb-3 heading-document">
                      <Col>
                        <span>OWNER DETAILS</span>
                      </Col>
                    </Row>
                  </>

                  <>
                    <Row>
                      <Col xs={12} md={8}>
                        <Row md={12}>
                          <Col md={6}>
                            <label>
                              Customer Name
                              <span className="text-danger">*</span>
                            </label>
                            <AvField
                              name="customer_name"
                              value={booking?.name || location.state?.name}
                              placeholder="Enter Customer Name"
                              type="text"
                              validate={{
                                required: {
                                  value: true,
                                  errorMessage: "Customer Name is required",
                                },
                              }}
                            />
                          </Col>
                          <Col md={6}>
                            <label>
                              Phone
                              <span className="text-danger">*</span>
                            </label>
                            <AvField
                              name="phone_number"
                              value={booking?.phone || location.state?.phone}
                              placeholder="Enter Phone Number"
                              type="text"
                              validate={{
                                required: {
                                  value: true,
                                  errorMessage: "Phone Number is required",
                                },
                              }}
                              pattern="^[0-9]{10}$"
                              errorMessage="Phone Number must be 10 digits"
                              maxLength="10"
                              minLength="10"
                            />
                          </Col>
                        </Row>
                        <Row className="" style={{ marginTop: "12px" }}>
                          <Col md={6}>
                            <label>State</label>
                            <Select
                              onInputChange={handleEnteredStates}
                              value={state}
                              placeholder={state}
                              onChange={handleFinalValuesStates}
                              options={stateOptions}
                              classNamePrefix="select2-selection"
                              isLoading={""}
                            />
                          </Col>
                          <Col md={6}>
                            <label>District</label>
                            <Select
                              isDisabled={!stateId}
                              onInputChange={handleEnteredDistrict}
                              value={district}
                              placeholder={district}
                              onChange={handleFinalValuesDistrict}
                              options={districtOptions}
                              classNamePrefix="select2-selection"
                              isLoading={""}
                            />
                          </Col>
                        </Row>
                      </Col>
                      <Col xs={12} md={4}>
                        <label>Address</label>
                        <AvField
                          name="address"
                          placeholder="Enter Address.."
                          type="textarea"
                          rows="5"
                        />
                      </Col>
                    </Row>
                  </>

                  <>
                    <Row className="bg-light px-1 mt-3 py-2 mb-1 heading-document">
                      <Col>
                        <span>OTHER DETAILS</span>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={6} className="d-flex align-items-end">
                        <div className="d-flex flex-column justify-content-center h-100 gap-1">
                          <Col className="col-6 mb-2">
                            <Label
                              className="mb-0"
                              style={{ marginLeft: "0px" }}
                            >
                              Finance
                            </Label>{" "}
                            <div className="d-flex align-items-center gap-3 mx-2">
                              <Label className="d-flex align-items-center gap-1 mb-0">
                                <Input
                                  type="radio"
                                  name="finance"
                                  value="yes"
                                  checked={isFeatured === true}
                                  onChange={() => setIsFeatured(true)}
                                />
                                Yes
                              </Label>
                              <Label className="d-flex align-items-center gap-1 mb-0">
                                <Input
                                  type="radio"
                                  name="finance"
                                  value="no"
                                  checked={isFeatured === false}
                                  onChange={() => setIsFeatured(false)}
                                />
                                No
                              </Label>
                            </div>
                          </Col>
                        </div>
                      </Col>
                      <Col md={6}>
                        <div className="pt-1">
                          <AvField
                            name="replacement_report"
                            label="Replacement Report"
                            placeholder="Enter Details"
                            type="textarea"
                            rows="2"
                          // maxLength="85"
                          />
                        </div>
                      </Col>
                    </Row>
                  </>

                  <Row className="pt-3 mb-2">
                    {inspectionSections.map((section, idx) => (
                      <div key={section.title}>
                        <Col
                          className="mb-2"
                          onClick={() => {
                            if (openSections.includes(idx)) {
                              setOpenSections(
                                openSections.filter(i => i !== idx)
                              )
                            } else {
                              setOpenSections([...openSections, idx])
                            }
                          }}
                          style={{
                            backgroundColor: "#FFF1DC",
                            color: "#B36200",
                            fontWeight: "500",
                            fontSize: "16px",
                            letterSpacing: "0.5px",
                            cursor: "pointer",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            padding: "8px 12px",
                            textDecoration: "uppercase",
                          }}
                        >
                          <span style={{ textTransform: "uppercase" }}>
                            {" "}
                            {section.title}
                          </span>
                          <i
                            className={`mdi ${openSections.includes(idx)
                              ? "mdi-chevron-up"
                              : "mdi-chevron-down"
                              }`}
                            style={{ fontSize: "20px" }}
                          />
                        </Col>
                        <div
                          style={{
                            display: openSections.includes(idx)
                              ? "block"
                              : "none",
                          }}
                        >
                          {/* If section has subHeads, render nested accordions */}
                          {section.isSub && Array.isArray(section.data)
                            ? section.data.map((sub, subHeadIdx) => (
                              <div key={sub.title}>
                                <div
                                  style={{
                                    background: "#EFF2F7",
                                    color: "#343A40",
                                    fontWeight: "bold",
                                    padding: "8px 12px",
                                    // borderRadius: 4,
                                    margin: "8px 0 4px 0",
                                    cursor: "pointer",
                                    fontSize: "13px",
                                  }}
                                  onClick={() => {
                                    // Toggle subHead open/close
                                    const key = `${idx}-${subHeadIdx}`
                                    setOpenSections(
                                      openSections.includes(key)
                                        ? openSections.filter(i => i !== key)
                                        : [...openSections, key]
                                    )
                                  }}
                                >
                                  {sub.title}
                                  <i
                                    className={`mdi ${openSections.includes(
                                      `${idx}-${subHeadIdx}`
                                    )
                                      ? "mdi-chevron-up"
                                      : "mdi-chevron-down"
                                      }`}
                                    style={{
                                      fontSize: "16px",
                                      float: "right",
                                    }}
                                  />
                                </div>
                                <div
                                  style={{
                                    display: openSections.includes(
                                      `${idx}-${subHeadIdx}`
                                    )
                                      ? "block"
                                      : "none",
                                  }}
                                >
                                  {sub.item.map((item, itemIdx) => (
                                    <React.Fragment key={itemIdx}>
                                      <div
                                        style={{
                                          minWidth: isTablet ? 380 : 480,
                                          borderRadius: 6,
                                          padding: "8px",
                                        }}
                                        className="mb-2 d-flex align-items-center"
                                      >
                                        <div
                                          className="d-flex align-items-center"
                                          style={{
                                            minWidth: isTablet ? 380 : 480,
                                          }}
                                        >
                                          <p
                                            className="mb-0"
                                            style={{
                                              fontSize: "13px",
                                              color: "#1C252E",
                                            }}
                                          >
                                            {/* {itemIdx + 1}. &nbsp; */}
                                            {section.isSub
                                              ? getGlobalIndex(
                                                idx,
                                                subHeadIdx,
                                                itemIdx
                                              )
                                              : getGlobalIndex(
                                                idx,
                                                undefined,
                                                index
                                              )}
                                            . &nbsp;
                                          </p>
                                          <p
                                            className="mb-0"
                                            style={{
                                              fontSize: "13px",
                                              color: "#1C252E",
                                            }}
                                          >
                                            {item}
                                          </p>
                                        </div>
                                        <div className="d-flex align-items-center justify-content-center pt-1 w-100">
                                          <div
                                            className=""
                                            style={{ marginBottom: "-2px" }}
                                          >
                                            <AvField
                                              className="custom-green-checkbox"
                                              type="checkbox"
                                              name={`check_metrics[${section.checkMetricIndex}].section.parameters[${subHeadIdx}].sub_parameters[${itemIdx}].status`}
                                              style={{
                                                accentColor: "#00A76F",
                                              }}
                                            />
                                          </div>
                                          <p
                                            className="pe-2 mb-0"
                                            style={{
                                              whiteSpace: "nowrap",
                                              marginTop: "2px",
                                            }}
                                          >
                                            &nbsp; Good
                                          </p>
                                          <div
                                            className="w-100"
                                            style={{ marginLeft: "8px" }}
                                          >
                                            <AvField
                                              style={{
                                                border: "1px solid #d1d1d1",
                                                minHeight: "40px",
                                              }}
                                              placeholder="Enter Details"
                                              type="text"
                                              // rows="1"
                                              // maxLength="32"
                                              name={`check_metrics[${section.checkMetricIndex}].section.parameters[${subHeadIdx}].sub_parameters[${itemIdx}].value`}
                                            />
                                          </div>
                                        </div>
                                      </div>
                                      {itemIdx !== sub.item.length - 1 && (
                                        <hr
                                          style={{
                                            border: "none",
                                            borderTop: "1px dotted grey",
                                            margin: "0 0 8px 0",
                                          }}
                                        />
                                      )}
                                    </React.Fragment>
                                  ))}
                                </div>
                              </div>
                            ))
                            : // No subHeads, render items directly
                            section.data?.map((i, index) => (
                              <React.Fragment key={index}>
                                <div
                                  style={{
                                    minWidth: isTablet ? 380 : 480,
                                    borderRadius: 6,
                                    padding: "8px",
                                  }}
                                  className="mb-2 d-flex align-items-center"
                                >
                                  <div
                                    className="d-flex align-items-center"
                                    style={{ minWidth: isTablet ? 380 : 480 }}
                                  >
                                    <p
                                      className="mb-0"
                                      style={{
                                        fontSize: "13px",
                                        color: "#1C252E",
                                      }}
                                    >
                                      {/* {section.data
                                          ? inspectionSections
                                              .slice(0, idx)
                                              .reduce(
                                                (acc, s) =>
                                                  acc +
                                                  (s.data ? s.data.length : 0),
                                                0
                                              ) +
                                            index +
                                            1
                                          : index + 1} */}
                                      {getGlobalIndex(idx, undefined, index)}.
                                      &nbsp;
                                    </p>
                                    <p
                                      className="mb-0"
                                      style={{
                                        fontSize: "13px",
                                        color: "#1C252E",
                                      }}
                                    >
                                      {section?.isSub ? i?.item : i}
                                    </p>
                                  </div>
                                  <div className="d-flex align-items-center justify-content-center pt-1 w-100">
                                    <div
                                      className=""
                                      style={{ marginBottom: "-2px" }}
                                    >
                                      <AvField
                                        className="custom-green-checkbox"
                                        type="checkbox"
                                        name={`check_metrics[${section.checkMetricIndex}].section.parameters[${index}].status`}
                                      />
                                    </div>
                                    <p
                                      className="pe-2 mb-0"
                                      style={{
                                        whiteSpace: "nowrap",
                                        marginTop: "2px",
                                      }}
                                    >
                                      &nbsp; Good
                                    </p>
                                    <div
                                      className="w-100"
                                      style={{ marginLeft: "8px" }}
                                    >
                                      <AvField
                                        style={{
                                          border: "1px solid #ccc",
                                          minHeight: "40px",
                                        }}
                                        placeholder="Enter Details"
                                        type="text"
                                        // maxLength="32"
                                        // rows="1"
                                        name={`check_metrics[${section.checkMetricIndex}].section.parameters[${index}].value`}
                                      />
                                    </div>
                                  </div>
                                </div>
                                {index !== section.data.length - 1 && (
                                  <hr
                                    style={{
                                      border: "none",
                                      borderTop: "1px dotted grey",
                                      margin: "0 0 8px 0",
                                    }}
                                  />
                                )}
                              </React.Fragment>
                            ))}
                        </div>
                      </div>
                    ))}
                  </Row>

                  <Row>
                    <Col md={6} />
                    <Col md={6}>
                      <div className="pt-1">
                        <AvField
                          name="remarks"
                          label="Remarks"
                          placeholder="Enter Remarks"
                          type="textarea"
                          rows="4"
                        // maxLength="85"
                        />
                      </div>
                    </Col>
                  </Row>

                  <div
                    className="d-flex align-items-center text-center "
                    style={{ marginTop: "1px" }}
                  >
                    <hr className="flex-grow-1 solid-line" />
                  </div>
                  <Row className="align-items-center justify-content-center">
                    <Col
                      md={2}
                      className="px-1"
                      style={{
                        width: "fit-content",
                        zIndex: 1000,
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "end",
                        justifyContent: "flex-end",
                      }}
                    >
                      <div className="w-100 d-flex align-items-center justify-content-end py-2 mb-0">
                        <Button
                          className="w-100 px-5 btn-rounded "
                          color="outline-warning"
                          onClick={() => history.goBack()}
                        >
                          {"close"}
                        </Button>
                      </div>
                    </Col>
                    <Col
                      md={2}
                      style={{
                        zIndex: 1000,
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "start",
                        justifyContent: "flex-start",
                      }}
                    >
                      <Button
                        className=" px-5 btn-rounded  fixed-width-button "
                        color="warning"
                        type="submit"
                        style={{ width: "200px !important" }}
                        disabled={loadingCreate}
                      >
                        {loadingCreate ? (
                          <div
                            className="spinner-border text-light"
                            role="status"
                            style={{ width: "1rem", height: "1rem" }}
                          />
                        ) : (
                          "Submit"
                        )}{" "}
                      </Button>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </>
        </Row>
      </AvForm>
    </div>
  )
}

export default Form

Form.propTypes = {
  updateData: PropTypes.any,
}
